exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".ly-skip-link {\n  background: #319795;\n  color: #fff;\n  font-weight: 700;\n  left: 50%;\n  padding: 4px;\n  position: absolute;\n  /* transform: translateY(-100%); */\n  /* transition: transform 0.3s; */\n}\n\n.ly-skip-link:focus {\n  /* transform: translateY(0%); */\n}\n", ""]);

